import styled from 'styled-components';
export const ToggleInput = styled.input.attrs({
  type: 'range',
  value: '2'
})`
  height: 26px;
  -webkit-appearance: none;
  margin: 10px 0;
  width: 100px;

  &focus {
    outline: none;
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    height: 26px;
    cursor: pointer;
    animate: 0.2s;
    box-shadow: 0px 0px 0px #000000;
    background: #e6e6e6;
    border-radius: 36px;
    border: 0px solid #010101;
  }
  &::-webkit-slider-thumb {
    box-shadow: 0px 0px 0px #000031;
    border: 0px solid #00001e;
    height: 20px;
    width: 20px;
    border-radius: 16px;
    background: #ffffff;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: 3px;
  }
  &:focus::-webkit-slider-runnable-track {
    background: #e6e6e6;
  }
  &::-moz-range-track {
    width: 100%;
    height: 26px;
    cursor: pointer;
    animate: 0.2s;
    box-shadow: 0px 0px 0px #000000;
    background: #e6e6e6;
    border-radius: 36px;
    border: 0px solid #010101;
  }
  &::-moz-range-thumb {
    box-shadow: 0px 0px 0px #000031;
    border: 0px solid #00001e;
    height: 20px;
    width: 20px;
    border-radius: 16px;
    background: #ffffff;
    cursor: pointer;
  }
  &::-ms-track {
    width: 100%;
    height: 26px;
    cursor: pointer;
    animate: 0.2s;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }
  [type='range']::-ms-fill-lower {
    background: #e6e6e6;
    border: 0px solid #010101;
    border-radius: 72px;
    box-shadow: 0px 0px 0px #000000;
  }
  &::-ms-fill-upper {
    background: #e6e6e6;
    border: 0px solid #010101;
    border-radius: 72px;
    box-shadow: 0px 0px 0px #000000;
  }
  &::-ms-thumb {
    margin-top: 1px;
    box-shadow: 0px 0px 0px #000031;
    border: 0px solid #00001e;
    height: 20px;
    width: 20px;
    border-radius: 16px;
    background: #ffffff;
    cursor: pointer;
  }
  &:focus::-ms-fill-lower {
    background: #e6e6e6;
  }
  &:focus::-ms-fill-upper {
    background: #e6e6e6;
  }
`;
export const Text = styled.p`
  font-size: 16px;
`;